export default "__VITE_ASSET__DlqBmIqa__"